import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

// material-ui
import withStyles from '@material-ui/core/styles/withStyles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import AppBar from '@material-ui/core/AppBar';

// components
import FamiliesList from 'components/FamiliesList';
import Loading from 'components/Loading';
import FormFamilie from 'components/FormFamilie';

// styles
import styles from './styles';

const indexDictinnary = {
  0: 'lens',
  1: 'tube',
  2: 'diff',
  3: 'briese',
  4: 'spotlight',
  5: 'PAR Matrix',
  6: 'Max',
  7: 'open face',
};

class WrapperFamiliePage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
    families: PropTypes.array,
    createFamilie: PropTypes.func,
    deleteFamilie: PropTypes.func,
    updateFamilie: PropTypes.func,

    // roles
    roles: PropTypes.array,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedFamilie: undefined,
      formFamilieOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { families, refresh, updateFamilie } = this.props;

    return (
      <FamiliesList
        families={families.filter(f => f.name === indexDictinnary[index])}
        onSelect={selectedFamilie => this.setState({
          selectedFamilie,
          formFamilieOpen: true,
        })}
        refresh={refresh}
        updateFamilie={updateFamilie}
      />
    );
  }

  render() {
    const {
      classes,
      history,
      loading,
      createFamilie,
      deleteFamilie,
      updateFamilie,
      refresh,
      roles,
    } = this.props;

    const {
      index,
      selectedFamilie,
      formFamilieOpen,
    } = this.state;

    return (
      <div className={`${classes.background} page`}>
        {
          loading
            ? (
              <Loading
                message={'Fetching all Families'}
              />
            )
            : (
              <div>
                <Helmet>
                  <title>Families</title>
                  <meta name="MyAccount" content="MyAccount page" />
                </Helmet>
                <AppBar position="static" className={classes.appBar}>
                  <Tabs
                    value={index}
                    onChange={(e, v) => {
                      this.setState({
                        index: v,
                      });
                      history.push(`?index=${v}`);
                    }}

                    indicatorColor="primary"
                    textColor="primary"
                    scrollable
                    scrollButtons="auto"
                    classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                  >
                    <Tab
                      label="lens"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                    <Tab
                      label="tube"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                    <Tab
                      label="diff"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                    <Tab
                      label="briese"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                    <Tab
                      label="spotlight"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                    <Tab
                      label="PAR Matrix"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                    <Tab
                      label="Max"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                    <Tab
                      label="Open Face"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                  </Tabs>
                </AppBar>
                <div className="container withAppBarAndTabs">
                  {
                    this.getStepContent()
                  }
                </div>
              </div>
            )
        }
        <Button
          variant="fab"
          color="primary"
          aria-label="Add"
          className={classes.floatingActionButton}
          onClick={() => this.setState({ formFamilieOpen: true })}
        >
          <AddIcon />
        </Button>
        <FormFamilie
          open={formFamilieOpen}
          familie={selectedFamilie}
          close={() => {
            this.setState({
              formFamilieOpen: false,
            });
            setTimeout(() => this.setState({
              selectedFamilie: undefined,
            }), 200);
          }
          }
          createFamilie={createFamilie}
          deleteFamilie={deleteFamilie}
          updateFamilie={updateFamilie}
          refresh={refresh}
          roles={roles}
        />
      </div>
    );
  }
}
export default withStyles(styles)(WrapperFamiliePage);
